import { h } from 'preact';

const FacebookIcon = () => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.83137 22.0001V13.2501H6.65637V9.62506H9.83137V6.86256C9.83137 3.72506 11.6939 2.00006 14.5564 2.00006C15.9189 2.00006 17.3439 2.23756 17.3439 2.23756V5.32506H15.7689C14.2189 5.32506 13.7314 6.28756 13.7314 7.27506V9.62506H17.2064L16.6439 13.2501H13.7314V22.0001H9.83137Z" fill="currentColor" />
</svg>
);

export default FacebookIcon;